import 'babel-runtime/core-js/promise';
import 'babel-runtime/core-js/object/keys';
import 'babel-runtime/core-js/json/stringify';
import 'babel-runtime/regenerator';
import 'babel-runtime/helpers/toConsumableArray';
import 'babel-runtime/helpers/asyncToGenerator';
import { e as callback, f as tag, g as append } from './chunks/chunk-d93006cb.js';
import _Object$create from 'babel-runtime/core-js/object/create';

var _window = window,
    HTMLElement = _window.HTMLElement,
    requestAnimationFrame = _window.requestAnimationFrame,
    cancelAnimationFrame = _window.cancelAnimationFrame;


var property = 'HTMLAnimationHeightElement';
var registeredStyle = {};

var animationHeight = window[property] = window[property] || document.registerElement('animation-height', {
  prototype: _Object$create(HTMLElement.prototype, {
    createdCallback: callback(create$$),
    attachedCallback: callback(attach$$),
    detachedCallback: callback(detach$$)
  })
});
var prototype = window[property].prototype;

function create$$(element) {
  registerStyle(element);
}

function attach$$(element) {
  element._updateRequest = requestAnimationFrame(function update() {
    var firstVisibleElement = element.firstElementChild;
    while (firstVisibleElement && !firstVisibleElement.offsetParent) {
      firstVisibleElement = firstVisibleElement.nextElementSibling;
    }

    if (firstVisibleElement) {
      var lastVisibleElement = element.lastElementChild;
      while (lastVisibleElement && !lastVisibleElement.offsetParent) {
        lastVisibleElement = lastVisibleElement.previousElementSibling;
      }
      element.style.height = lastVisibleElement.offsetTop + lastVisibleElement.offsetHeight - 0 /* TODO: must differentiate between self padding and child margins */ + 'px';
    } else {
      element.style.height = 0;
    }

    element._updateRequest = requestAnimationFrame(update);
  });
}

function detach$$(element) {
  cancelAnimationFrame(element._updateRequest);
}

function registerStyle(element) {
  var TAG = element.tagName;
  if (registeredStyle[TAG]) {
    return;
  }
  registeredStyle[TAG] = true;

  var styleElement = tag('style');
  append(document.head, styleElement);
  styleElement.textContent = '\n    ' + TAG + ' {\n      display: block;\n      position: relative;\n      overflow: hidden;\n      transition-duration: 500ms;\n    }\n  ';
}

export default animationHeight;
export { prototype };
